import { env } from '@hackvegas-2025/shared';
import { Color, Command, parseServerMessage, UserMessageInput } from '@hackvegas-2025/shared';
import { removeCommand, resetState, state, log } from './state';

export function initWebsocket(code: string) {
  state.code = code;
  const socket = new WebSocket(`${env.wsUrl}?code=${code}`);

  socket.onmessage = (e) => {
    console.log(e.data);
    const message = parseServerMessage(e.data);
    switch (message.kind) {
      case 'world': {
        const newCommands = message.value.commandsUnlocked.filter(
          (command) => !state.availableCommands.includes(command),
        );
        if (newCommands.length === 1) {
          log(`New command available: ${newCommands[0]}`);
        } else if (newCommands.length > 1) {
          log(`New commands available: ${newCommands.join(', ')}`);
        }
        for (const command of newCommands) {
          state.availableCommands.push(command);
        }
        removeCommand(Command.login);
        for (const color of message.value.nextUserColors) {
          if (!state.availableColors.includes(color)) {
            state.availableColors.push(color);
          }
        }

        if (message.value.bootGame.completed && state.availableCommands.includes(Command.boot)) {
          removeCommand(Command.boot);
          const newColors = Object.values(Color).filter((color) => !state.availableColors.includes(color));
          for (const color of newColors) {
            state.availableColors.push(color);
          }
          if (newColors.length > 0) {
            log(`New colors available: ${newColors.join(',')}`);
          }
        }

        break;
      }
      // todo: this is probably redundant with the `world` server message now.
      // case 'unlock': {
      //   if (!state.availableCommands.includes(message.value)) {
      //     state.availableCommands.push(message.value);
      //     log(`New command available: ${message.value}`);
      //   }
      //   break;
      // }
      default: {
        log(message.value);
      }
    }
  };

  socket.onclose = () => {
    log('Connection closed');
    resetState();
    log(`Available commands: ${state.availableCommands.join(', ')}`);
  };

  function pollForSocketConnected() {
    return new Promise<void>((resolve) => {
      const interval = setInterval(() => {
        if (socket.readyState !== WebSocket.CONNECTING) {
          clearInterval(interval);
          resolve();
        }
      }, 100);
    });
  }

  function send(command: UserMessageInput) {
    socket.send(JSON.stringify({ ...command, code, color: state.color }));
  }

  return { send, pollForSocketConnected };
}
